import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import {
  selectAllEntityAppointments,
  useGetEntityAppointmentsOnMount,
} from '@user/store/scheduling'
import { filterByEntity } from '@sales-center/common'
import { AppointmentsPopoverContentProps } from '../typing'

export function usePopoverContentData(params: AppointmentsPopoverContentProps) {
  const { entityId, entityType } = params
  const loading = useGetEntityAppointmentsOnMount(entityId, entityType)

  const allAppts = useSelector(selectAllEntityAppointments)

  const { appointmentId, newestAppointment } = useMemo(() => {
    const curDateTime = new Date()

    const appts = filterByEntity(allAppts, entityId, entityType).filter(
      (x) =>
        x.status === 'Scheduled' &&
        x.workTime &&
        new Date(x.workTime) > curDateTime,
    )

    const newestAppointment = appts.length === 0 ? undefined : appts[0]

    const appointmentId = newestAppointment?.appointmentId

    return {
      appointmentId,
      newestAppointment,
    }
  }, [allAppts, entityId, entityType])

  const error = newestAppointment === undefined || loading === 'fail'

  return {
    error,
    loading,
    appointmentId,
    newestAppointment,
  }
}
